import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixToggle from '@radix-ui/react-switch';
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { transitionDuration } from '../../const/transitionDuration';
import { transitionTimingFunction } from '../../const/transitionTimingFunction';
import { getDisabledColorOpacity } from '../../helpers/getColorOpacity';
import { useTestIdAttribute, } from '../../hooks/useTestIdAttribute';
import { useIsCheckedTestAttribute } from '../inputs/useIsCheckedTestAttribute';
const StyledRoot = styled(RadixToggle.Root, (p) => {
    const toggleBackgroundColor = p.$checked
        ? staticColors.toggleCheckedBackground
        : staticColors.toggleUncheckedBackground;
    const backgroundColor = p.$disabled
        ? getDisabledColorOpacity(toggleBackgroundColor)
        : toggleBackgroundColor;
    return {
        position: 'relative',
        width: sizes.toggle.width,
        height: sizes.toggle.height,
        padding: 0,
        // Because thumb outline overflows element dimensions
        margin: sizes.toggle.thumbOutline,
        border: 'none',
        borderRadius: sizes.toggle.height,
        backgroundColor,
        transitionDuration: transitionDuration.medium,
        transitionProperty: 'background-color',
        transitionTimingFunction: transitionTimingFunction.ease,
        ':hover': {
            cursor: p.$disabled ? 'not-allowed' : 'pointer',
        },
    };
});
const StyledThumb = styled('div', (p) => {
    const left = p.$checked
        ? `calc(${sizes.toggle.width} - ${sizes.toggle.height})`
        : 0;
    const thumbOutlineColor = p.$checked
        ? staticColors.toggleCheckedBackground
        : staticColors.toggleUncheckedBackground;
    const outlineColor = p.$disabled
        ? getDisabledColorOpacity(thumbOutlineColor)
        : thumbOutlineColor;
    return {
        position: 'absolute',
        top: 0,
        left,
        width: sizes.toggle.height,
        height: sizes.toggle.height,
        borderRadius: '50%',
        backgroundColor: staticColors.toggleThumbBackground,
        outlineWidth: sizes.toggle.thumbOutline,
        outlineColor,
        outlineStyle: 'solid',
        transitionDuration: transitionDuration.medium,
        transitionProperty: 'left outline-color',
        transitionTimingFunction: transitionTimingFunction.ease,
    };
});
export const Toggle = ({ checked, disabled, testId, onChange, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const isCheckedTestAttribute = useIsCheckedTestAttribute(checked);
    return (_jsx(StyledRoot, { $checked: checked, $disabled: disabled, checked: checked, disabled: disabled, ...testIdAttribute, ...isCheckedTestAttribute, onCheckedChange: onChange, children: _jsx(StyledThumb, { $checked: checked }) }));
};
